import { render, staticRenderFns } from "./AIBetaBadge.vue?vue&type=template&id=2be3f291&scoped=true"
import script from "./AIBetaBadge.vue?vue&type=script&lang=js"
export * from "./AIBetaBadge.vue?vue&type=script&lang=js"
import style0 from "./AIBetaBadge.vue?vue&type=style&index=0&id=2be3f291&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be3f291",
  null
  
)

export default component.exports